import React, { useEffect, useState } from 'react';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import {
  List,
  Button,
  Input,
  Divider,
  Select,
  Form,
  message,
  Popconfirm,
} from 'antd';
import Paragraph from 'antd/lib/typography/Paragraph';
import { Container } from './styles';
import api from '../../services/api';
import { useArea } from '../../context/AreaContext';
import { basicSuccessFeedback, negativeFeedback } from '../../utils/feedback';

const { Search } = Input;
const { Option } = Select;

interface IProps {
  categories: Array<any>;
}

const SubcategoriesList: React.FC<IProps> = ({ categories }) => {
  const [subCategories, setSubCategories] = useState<Array<any>>([]);
  const [category, setCategory] = useState<number | string>();
  const { area } = useArea();

  useEffect(() => {
    getSubCategories();
  }, [category]);

  const getSubCategories = async () => {
    if (!category) {
      return;
    }
    try {
      const { data } = await api.get(
        `/${area.endpoint}/subcategories?categoryId=${category}`,
      );

      setSubCategories(data);
    } catch (err) {
      message.error(negativeFeedback);
    }
  };

  const handleAdd = async (name: string) => {
    if (!name) {
      return;
    }

    try {
      await api.post(`/${area.endpoint}/subcategory`, {
        categoryId: category,
        name,
      });
      message.success(basicSuccessFeedback);
      getSubCategories();
    } catch (err) {
      message.error(negativeFeedback);
    }
  };

  const handleCategory = (id: number | string) => {
    setCategory(id);
  };

  const handleDelete = async (id: number) => {
    try {
      await api.delete(`/${area.endpoint}/subcategory/${id}`);
      message.success(basicSuccessFeedback);
      getSubCategories();
    } catch (err) {
      message.error(negativeFeedback);
    }
  };

  const handleUpdate = async (name: string, id: string) => {
    try {
      await api.put(`/${area.endpoint}/subcategory`, {
        id,
        name,
      });
      message.success(basicSuccessFeedback);
      getSubCategories();
    } catch (err) {
      message.error(negativeFeedback);
    }
  };

  const subcategoryTitle = (name: string, id: string) => (
    <Paragraph
      style={{ marginBottom: 0 }}
      editable={{
        onChange: (newName: string) => {
          handleUpdate(newName, id);
        },
      }}
    >
      {name}
    </Paragraph>
  );

  return (
    <>
      <Form layout="vertical">
        <Form.Item name="category" label="Selecione a Categoria:">
          <Select onChange={handleCategory}>
            {categories.map(item => (
              <Option value={item.id}>{item.name}</Option>
            ))}
          </Select>
        </Form.Item>
      </Form>

      <Search
        placeholder="Adicionar Subcategoria"
        allowClear
        enterButton={<PlusOutlined />}
        onSearch={handleAdd}
      />
      <Divider />
      <Container>
        <List
          dataSource={subCategories}
          renderItem={item => (
            <List.Item key={item.id}>
              <List.Item.Meta title={subcategoryTitle(item.name, item.id)} />
              <div>
                <Popconfirm
                  title="Excluir a subcategoria e todos os produtos vinculados à ela?"
                  onConfirm={() => {
                    handleDelete(item.id);
                  }}
                  okText="Excluir"
                  cancelText="Cancelar"
                >
                  <Button type="link" danger>
                    <DeleteOutlined />
                  </Button>
                </Popconfirm>
              </div>
            </List.Item>
          )}
        />
      </Container>
    </>
  );
};

export default SubcategoriesList;
